import React from "react";
import AppTranslation from "../../../service/app_translation/AppTranslation";

const Loader = new (class Loader {
  normal = (): JSX.Element => {
    return (
      <div className={`spinner-border color-primary`} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  };

  modal = (status: boolean = true) => {
    if (status) {
      document.body.classList.remove("show-processing");
      document.body.classList.add("show-processing");
    } else {
      document.body.classList.remove("show-processing");
    }
  };

  modalHtml = (): JSX.Element => {
    return (
      <div className="modal-loader">
        <div className="d-flex align-items-center">
          <div className="spinner-border color-white" role="status"></div>
          <div className="ms-3 font-size-16_17 font-gotham-bold color-white">
            {AppTranslation.text("please_wait")}
          </div>
        </div>
      </div>
    );
  };
})();

export default Loader;
